// core version + certain modules modules:
import SwiperCore, {Navigation, Pagination, Autoplay, EffectFade, Controller, Thumbs} from 'swiper/core';

// configure Swiper to use modules
SwiperCore.use([Navigation, Pagination, Autoplay, EffectFade, Controller, Thumbs]);

if ($('.product-slider').length) {
    let thumbSlider = new SwiperCore('.thumb-slider ', {
        loop: false,
        slidesPerView: 5,
        spaceBetween: 10,
        watchSlidesProgress: true,
        direction: "horizontal",
        breakpoints: {
            768: {
                direction: "vertical",
                spaceBetween: 25
            }
        }
    });

    let imageSlider = new SwiperCore('.product-image-slider ', {
        loop: false,
        slidesPerView: 1,
        spaceBetween: 3,
        navigation: {
            nextEl: '.swiper-buttons__button--next',
            prevEl: '.swiper-buttons__button--prev',
        },
        thumbs: {
            swiper: thumbSlider
        }
    });

    thumbSlider.on('slideChange', function () {
        $('.thumb-overlay').addClass('slider-active');
    });

    $('.thumb-overlay').on("click", function (e) {
        $(this).addClass('slider-active');
    });
}

let logoSlider = new SwiperCore('.logo-slider ', {
    spaceBetween: 80,
    loop: true,
    slidesPerView: 1.5,
    direction: 'horizontal',
    autoplay: {
        delay: 0,
    },
    speed: 2000,
    loopAdditionalSlides: 1,
    breakpoints: {
        560: {
            slidesPerView: 3,
        },
        768: {
            slidesPerView: 4,
        },
        992: {
            slidesPerView: 6,
        }
    }
});

let reviewSlider = new SwiperCore('.review-slider ', {
    spaceBetween: 0,
    loop: true,
    navigation: {
        nextEl: '.swiper-buttons__button--next',
        prevEl: '.swiper-buttons__button--prev',
    },
});

let imageSlider = new SwiperCore('.image-slider ', {
    spaceBetween: 40,
    slidesPerView: 1,
    autoplay: true,
    loop: true,
    pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
    },
    loopAdditionalSlides: 1,
    breakpoints: {
        768: {
            pagination: false,
        },
    }
});

if ($(window).width() > 767) {

    let categoriesSlider = new SwiperCore('.categories--slider ', {
        spaceBetween: 16,
        loop: false,
        slidesPerView: 2,
        direction: 'horizontal',
        navigation: {
            prevEl: '.swiper-buttons__button--prev',
            nextEl: '.swiper-buttons__button--next'
        },
        breakpoints: {
            560: {
                slidesPerView: 3,
            },
            768: {
                slidesPerView: 3,
            },
            1024: {
                slidesPerView: "auto",
            }
        }
    });

    let timelineSlider = new SwiperCore('.timeline-slider ', {
        loop: false,
        slidesPerView: 2,
        spaceBetween: 40,
        navigation: {
            nextEl: ".swiper-buttons__button--next",
            prevEl: ".swiper-buttons__button--prev",
        },
        breakpoints: {
            992: {
                slidesPerView: 2,
                spaceBetween: 80,
            },
        }
    });

    jQuery(document).ready(function ($) {

        if ($('.category-list').length > 0) {
            document.querySelectorAll('.category-list input').forEach((el) => {
                if (el.value) {
                    categoriesSlider.update();
                }
            })
        }
    });
}
